<template>
  <section>
    <h1 class="text-h3 mb-8">
      Spacing
    </h1>
    <h2 class="text-h4 mb-4">
      Spacing levels
    </h2>
    <v-container class="mb-4">
      <v-row
        v-for="r in 4"
        :key="r"
      >
        <v-col
          v-for="c in 4"
          :key="c"
          class="d-flex flex-column justify-end"
        >
          <div
            class="secondary fill-width"
            :style="{ height: computeSpacingSize(r, c) }"
          />
          <div class="py-1">
            {{ computeSpacingSize(r, c) }}
            <v-chip
              class="ml-1"
              x-small
            >
              Level {{ computeSpacingLevel(r, c) }}
            </v-chip>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <h2 class="text-h4 mb-4">
      Syntax
    </h2>
    <p>
      Usage: <code>.{property}{direction}[-{breakpoint}]-{size}</code><br>
      e.g. <code>.pa-4</code>, <code>.pa-2.pb-6</code>, <code>.px-4.px-md-8</code>
    </p>
    <v-simple-table class="mb-4">
      <thead>
        <tr class="text-left">
          <th
            v-for="header in headers"
            :key="header"
          >
            {{ header }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="syntax in syntaxes"
          :key="syntax.type"
        >
          <td>
            <strong>
              {{ syntax.type }}
            </strong>
          </td>
          <td class="py-2">
            <ul>
              <li
                v-for="(value, i) in syntax.values"
                :key="i"
              >
                {{ value }}
              </li>
            </ul>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
    <h2 class="text-h4 mb-4">
      Further reading
    </h2>
    <external-link href="https://vuetifyjs.com/en/features/breakpoints/">
      <strong>Spacing helper classes</strong>
    </external-link>
    <div
      ref="target"
      class="mt-1"
      hidden
    />
  </section>
</template>

<script>
export default {
  name: 'StylesBreakpoints',
  data: () => ({
    level: 4
  }),
  computed: {
    headers () {
      return [
        'Type',
        'Value'
      ]
    },
    syntaxes () {
      return [
        {
          type: 'property',
          values: [
            'm (margin)',
            'p (padding)'
          ]
        },
        {
          type: 'direction',
          values: [
            't (top)',
            'b (bottom)',
            'l (left)',
            'r (right)',
            's (start, left in LTR, right in RTL)',
            'e (end, right in LTR, left in RTL)',
            'x (left + right)',
            'y (top + bottom)',
            'a (all)'
          ]
        },
        {
          type: 'breakpoint',
          values: [
            'xs',
            'sm',
            'md',
            'lg',
            'xl'
          ]
        },
        {
          type: 'size',
          values: [
            '0',
            '1~16 (positive level)',
            'n1~n16 (negative level)',
            'auto'
          ]
        }
      ]
    }
  },
  mounted () {
    this.getSpacingLevel()
  },
  methods: {
    getSpacingLevel () {
      const target = this.$refs.target
      if (target) {
        const style = getComputedStyle(target)
        const marginTop = style.marginTop
        this.level = Number(marginTop.replace('px', '')) || 0
      }
    },
    computeSpacingLevel (row, col) {
      return col + this.level * (row - 1)
    },
    computeSpacingSize (row, col) {
      return this.computeSpacingLevel(row, col) * this.level + 'px'
    }
  }
}
</script>
